import * as Sentry from '@sentry/react';
import { ENVIRONMENT, SENTRY_DSN } from 'config';

export interface SessionEventContext {
  reason: string;
  enforced: boolean;
  status?: number | null;
  host?: string | null;
  coreVersion?: string | null;
  code?: string | null;
}

/**
 * Report a session-lifecycle signal.
 *
 * Only ever given coarse, non-identifying facts — a reason, an HTTP status and
 * which backend answered. Never a URL (Core puts auth tokens in the path), a
 * response body, a token or a user identifier.
 */
export const reportSessionEvent = (message: string, context: SessionEventContext): void => {
  const tags = {
    session_reason: context.reason,
    session_status: String(context.status ?? 'none'),
    session_host: context.host ?? 'none',
    session_core_version: context.coreVersion ?? 'none',
    session_code: context.code ?? 'none',
    session_enforced: String(context.enforced),
  };

  // Sentry drops every event in development (see `beforeSend` in index.tsx).
  if (!SENTRY_DSN || ENVIRONMENT.isDev) {
    console.warn(`[session] ${message}`, tags);
    return;
  }

  Sentry.captureMessage(message, { level: 'warning', tags });
};
